/**
 * Required Module
 */
import { get } from 'axios';
import { ENDPOINT } from './../config/endpoints';

/**
 * Function for fetching the single
 * catalog Item
 * @param {number} storeId
 * @param {number} itemId
 * @return {object}
 */
async function getCatalogItemById(storeId, itemId) {
  try {
    const response = await get(ENDPOINT.CATALOG.getItemById(storeId, itemId), {
      headers: {
        app_os: 'cfe',
      },
    });
    return { error: null, data: response.data };
  } catch (error) {
    return { error };
  }
}

/**
 * Function for fetching the single
 * catalog Item by using product slug url
 * @param {number} storeId
 * @param {number} productSlug
 * @return {object}
 */
async function getCatalogItemBySlug(storeId, productSlug) {
  try {
    const response = await get(ENDPOINT.CATALOG.getItemBySlug(storeId, productSlug), {
      headers: {
        app_os: 'cfe',
      },
    });

    return { error: null, data: response.data };
  } catch (error) {
    return { error };
  }
}

/**
 * Function for fetching the
 * catalog categories
 * @param {number} storeId
 * @return {object}
 */
async function getCatalogCategories(storeId) {
  try {
    const response = await get(ENDPOINT.CATALOG.getCategories(storeId), {
      headers: {
        app_os: 'cfe',
      },
    });
    return { error: null, data: response.data };
  } catch (error) {
    return { error };
  }
}

/**
 * Function for fetching all collections data
 * @param {*} storeId
 * @return {Array}
 */
async function getCollectionData(storeId) {
  try {
    const response = await get(ENDPOINT.CATALOG.getAllCollectionsData(storeId), {
      headers: {
        app_os: 'cfe',
      },
    });
    return { error: null, data: response.data };
  } catch (error) {
    return { error };
  }
}

/**
 * fetch the canonical url for different pages
 */
async function getPageCanonicalUrl({ storeId, type, typeId, slug_url = '' }) {
  try {
    const response = await get(
      ENDPOINT.CATALOG.getPageLink(storeId, type, typeId, slug_url),
      {
        headers: {
          app_os: 'cfe',
        },
      }
    );

    return response.data;
  } catch (error) {
    return {};
  }
}

/**
 * Add Exported Function here
 */
export {
  getCatalogItemById,
  getCatalogItemBySlug,
  getCatalogCategories,
  getCollectionData,
  getPageCanonicalUrl,
};
